<!-- A simple circle whose background color reflects how old the displayed store's data is -->
<div
  [matTooltip]="timeSinceUpdate()"
  [matTooltipClass]="'freshness-indicator-tooltip'"
  [ngStyle]="{'background-color': colour()}"
  class="circle">
</div>
